import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["list", "template"]
  static values = { property: String, index: Number }

  add(event) {
    event.preventDefault()
    const i = this.indexValue
    const html = this.templateTarget.innerHTML.replaceAll("_i_", i)

    const wrapper = document.createElement("div")
    wrapper.id = `${this.propertyValue}-${i}_container_`
    wrapper.innerHTML = html

    wrapper.querySelectorAll("[disabled]").forEach(el => el.removeAttribute("disabled"))
    wrapper.querySelectorAll("[data-template]").forEach(el => el.removeAttribute("data-template"))

    this.listTarget.appendChild(wrapper)
    this.indexValue = i + 1
  }

  remove(event) {
    event.preventDefault()
    event.currentTarget.closest("[id$='_container_']")?.remove()
  }
}
